import styled, { css } from 'styled-components';

export const Container = styled.div<{ align: 'top' | 'center' | 'bottom' }>`
  position: absolute;
  z-index: 2;
  left: 0;

  ${({ align }) =>
    align === 'center' &&
    css`
      top: -275px;
    `}

  ${({ align }) =>
    align === 'bottom' &&
    css`
      top: 64px;
    `}

  ${({ align }) =>
    align === 'top' &&
    css`
      bottom: 64px;
    `}
`;
